import { SUPPORT_EMAIL_MAIL_TO } from "@/constants"
import { Component } from "@/types/types"
import { ButtonLink } from "@/ui/atoms/controls/ButtonLink"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { SplashCard } from "@/ui/atoms/layout/SplashCard"
import { Stack } from "@/ui/atoms/layout/Stack"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "signUpConfirmation"

export const presets = {}

export interface Props extends Component {
  email: string
}

export function DemoSignUpConfirmation({ email, className, testId = COMPONENT_NAME }: Props) {
  return (
    <SplashCard className={cx(`w-full max-w-screen-form text-center`, className)} testId={testId}>
      <Stack className="gap-8">
        <header>
          <Stack className="gap-6">
            <Title size="lg" className="text-center">
              Please verify your email
            </Title>

            <BodyText size="md">
              We've just sent an email to: <br /> <span className="font-bold">{email}</span>
            </BodyText>
            <BodyText size="md">
              Simply click on the link in the email to verify your email address and complete your
              sign up. If you don’t receive an email from us, please check your spam folder.
            </BodyText>
          </Stack>
        </header>

        <footer>
          <Stack className="gap-6">
            <ButtonLink label="Return to sign in" variant="primary" href="/sign-in" width="full" />
            <TextLink href={SUPPORT_EMAIL_MAIL_TO} style="bold">
              Still haven't received an email? Contact us
            </TextLink>
          </Stack>
        </footer>
      </Stack>
    </SplashCard>
  )
}
